import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Review = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_3208_247)">
        <g filter="url(#filter0_di_3208_247)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4616 13.6743C21.5515 13.6743 24.5233 18.3092 24.5233 22.0146C24.5233 25.72 15.9932 26.3194 13.4616 26.3194L13.4616 26.3189C10.9301 26.3189 2.3999 25.7195 2.3999 22.0141C2.3999 18.3087 5.37171 13.7172 13.4616 13.7172L13.4616 13.6743Z"
            fill="url(#paint0_linear_3208_247)"
          />
        </g>
        <g filter="url(#filter1_di_3208_247)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4614 2.3999C9.42902 2.3999 7.41284 5.5059 7.41284 8.0125C7.41284 11.4998 10.0826 14.7398 13.4608 14.7401C13.4612 14.7502 13.4613 14.7599 13.4613 14.7694C16.8398 14.7694 19.5099 11.4999 19.5099 8.0125C19.5099 5.5059 17.4937 2.3999 13.4614 2.3999Z"
            fill="url(#paint1_radial_3208_247)"
          />
        </g>
        <g filter="url(#filter2_d_3208_247)">
          <path
            d="M21.9999 14.3999L23.1481 15.4884L24.5993 14.8582L25.3059 16.2737L26.8851 16.178L27.065 17.7498L28.5817 18.1999L28.2132 19.7385L29.4844 20.6802L28.6119 21.9999L29.4844 23.3196L28.2132 24.2613L28.5817 25.7999L27.065 26.25L26.8851 27.8218L25.3059 27.7261L24.5993 29.1416L23.1481 28.5115L21.9999 29.5999L20.8517 28.5115L19.4005 29.1416L18.6939 27.7261L17.1147 27.8218L16.9348 26.25L15.4181 25.7999L15.7867 24.2613L14.5154 23.3196L15.3879 21.9999L14.5154 20.6802L15.7867 19.7385L15.4181 18.1999L16.9348 17.7498L17.1147 16.178L18.6939 16.2737L19.4005 14.8582L20.8517 15.4884L21.9999 14.3999Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter3_di_3208_247)">
          <path
            d="M18.8 22.6632L21.5369 25.1998L25.2001 18.7998"
            stroke="#A116E3"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_di_3208_247"
          x="-0.600098"
          y="13.6743"
          width="28.1235"
          height="19.645"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3208_247" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3208_247" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.5" dy="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_3208_247" />
        </filter>
        <filter
          id="filter1_di_3208_247"
          x="4.41284"
          y="2.3999"
          width="18.0969"
          height="19.3696"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3208_247" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3208_247" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.5" dy="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_3208_247" />
        </filter>
        <filter
          id="filter2_d_3208_247"
          x="10.5154"
          y="11.3999"
          width="22.969"
          height="23.2002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.612928 0 0 0 0 0.517833 0 0 0 0 0.656657 0 0 0 0.33 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3208_247" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3208_247" result="shape" />
        </filter>
        <filter
          id="filter3_di_3208_247"
          x="13.8"
          y="17.7998"
          width="16.4001"
          height="16.3999"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3208_247" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3208_247" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.1" dy="0.1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.95 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_3208_247" />
        </filter>
        <linearGradient
          id="paint0_linear_3208_247"
          x1="13.4616"
          y1="16.7212"
          x2="13.4616"
          y2="26.3194"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5D00D4" />
          <stop offset="1" stopColor="#BD2AF0" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_3208_247"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.1875 5.821) rotate(51.1466) scale(9.24554 9.04186)"
        >
          <stop stopColor="#A52AF0" />
          <stop offset="1" stopColor="#5D00D4" />
        </radialGradient>
        <clipPath id="clip0_3208_247">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default Review
